import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import ProgressBar from "react-bootstrap/ProgressBar";

//Slider
import Slider from "react-input-slider";

// Icons
import {
  RiCheckboxMultipleBlankLine,
  RiCheckboxMultipleLine,
  RiCheckboxMultipleFill,
} from "react-icons/ri";

import { AuthContext } from "../store/AuthProvider";

import "./css/components.css";
import Loading from "./Loading";

const TaskDesciption = ({ taskDetails }) => {
  return (
    <div className="taskDetails">
      {taskDetails.short_description}
      <p />
      <h4>Languages</h4>
      {taskDetails.languages.join(", ")}
      <p />
      <h4>Tags</h4>
      <div className="flexRowWrap">
        {taskDetails.tags.map((tag, index) => (
          <div key={index} className="tag">
            {tag}
          </div>
        ))}
      </div>
    </div>
  );
};

const CustomToggle = ({ children, eventKey, callback }) => {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isCurrentEventKey = currentEventKey === eventKey;
  return (
    <Card.Header
      className="qtypeHeader"
      style={{ color: isCurrentEventKey ? "rgb(0,123,255)" : "black" }}
      onClick={decoratedOnClick}
    >
      {children}
    </Card.Header>
  );
};

const HeaderForOne = ({ sessionsProgress, qtype }) => (
  <>
    <span>{qtype}</span>
    <span>
      Completed: {sessionsProgress[qtype].filter((x) => x == 100).length} /{" "}
      {sessionsProgress[qtype].length} session
    </span>
  </>
);

const HeaderForMultiple = ({ sessionsProgress, qtype }) => (
  <>
    <span>{qtype}</span>
    <span>
      Completed: {sessionsProgress[qtype].filter((x) => x == 100).length} /{" "}
      {sessionsProgress[qtype].length} sessions
    </span>
  </>
);

const SessionsList = ({
  taskId,
  quanta,
  setQuanta,
  questionTypeMapping,
  sessionsProgress,
}) => {
  return (
    <>
      <Accordion defaultActiveKey={1}>
        {Object.keys(sessionsProgress).map((qtype, qindex) => (
          <Card key={qindex}>
            <CustomToggle as={Card.Header} eventKey={qindex + 1}>
              {sessionsProgress[qtype].length === 1 ? (
                <HeaderForOne sessionsProgress={sessionsProgress} qtype={qtype}/>
              ) : (
                <HeaderForMultiple sessionsProgress={sessionsProgress} qtype={qtype}/>
              )}
            </CustomToggle>
            <Accordion.Collapse eventKey={qindex + 1}>
              <div
                className="flexRowWrap spaceEvenly enableScroll"
                style={{ maxHeight: "45vh" }}
              >
                {sessionsProgress[qtype].map((progress, index) => (
                  <Link
                    to={`/task=${taskId}/${questionTypeMapping[qtype]}/${index}.${quanta}`}
                    key={index}
                  >
                    <div className="box session">
                      <div className="smName">
                        <span className="spChar">S</span>ession{" "}
                        <span className="spChar">{index + 1}</span>
                      </div>

                      {progress === 100 ? (
                        <RiCheckboxMultipleFill
                          className="alignCenter"
                          size={42}
                        />
                      ) : (
                        <RiCheckboxMultipleBlankLine
                          className="alignCenter"
                          size={42}
                        />
                      )}

                      <ProgressBar now={progress} label={`${progress}%`} />
                    </div>
                  </Link>
                ))}
              </div>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>

      <div
        style={{
          marginTop: "5px",
          marginRight: "auto",
          marginLeft: "auto",
          textAlign: "center",
        }}
      >
        <Slider
          axis="x"
          xstep={1}
          xmin={1}
          xmax={30}
          x={quanta}
          onChange={(e) => {
            setQuanta(e.x);
          }}
          styles={{ active: { backgroundColor: "rgb(0,123,255)" } }}
          style={{ width: "250px" }}
        />

        <p>
          {quanta === 1 ? (
            <>
              <span className="spChar">1</span> question per session.{" "}
            </>
          ) : (
            <>
              <span className="spChar">{quanta}</span> questions per session.
            </>
          )}
        </p>
      </div>
    </>
  );
};

const Sessions = (props) => {
  const { userState, _ } = useContext(AuthContext);
  const [userAuthToken, setUserAuthToken] = userState;

  const [taskDetails, setTaskDetails] = useState({});
  const [quanta, setQuanta] = useState(20);
  const taskId = props.match.params.taskId;

  useEffect(() => {
    const getSessionDetails = async () => {
      let taskUri = `${process.env.REACT_APP_API}/task/${taskId}`;
      if (userAuthToken) {
        taskUri = `${taskUri}?auth_token=${userAuthToken}&session_length=${quanta}`;
      } else {
        taskUri = `${taskUri}?session_length=${quanta}`;
      }
      console.log(taskUri);
      const response = await fetch(taskUri);
      const data = await response.json();
      console.log("data", data);
      setTaskDetails(data.response);

      // HARD CODE
      //   setTaskDetails({'response':'success',
      //                         '_id':'dummyID',
      //                         'session_progress':{
      //                                                     'Descriptive':[12, 0, 50, 0, 0, 0, 0],
      //                                                     'MCQ':[0, 20, 0, 0],
      //                                                     'MCQ Multi-Correct':[10, 0, 100, 0]
      //                                                   },
      //                         'name':'Dummy',
      //                         'details':'dummy details',
      //                         'short_description':'dummy short description',
      //                         'tags':['du', 'mm', 'y'],
      //                         'languages':['du', 'my']
      //                       });
    };
    getSessionDetails();
  }, [quanta, taskId]);

  if (Object.keys(taskDetails).includes("error")) {
    return <Loading message={taskDetails.error} />;
  } else if (Object.keys(taskDetails).length !== 13) {
    // hack while loading the questions
    return <Loading />;
  }

  console.log("task details", taskDetails);
  return (
    <div className="mainSpace">
      <div className="breadCrumbs">
        <Link to="/">
          <span className="spChar">H</span>ome
        </Link>
        <span className="spChar spaceAround">/</span>
        <span className="spChar">{taskDetails.name.charAt(0)}</span>
        {taskDetails.name.slice(1)}
      </div>

      <Tab.Container id="left-tabs" defaultActiveKey="first">
        <Row style={{ fontSize: "110%" }}>
          <Col sm={4}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">Description</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">Start Task</Nav.Link>
              </Nav.Item>
              <Nav.Item style={{ marginTop: "2em" }}>
                <Link
                  to="#"
                  onClick={() => {
                    props.history.goBack();
                  }}
                >
                  <Nav.Link href="#/">Back</Nav.Link>
                </Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <TaskDesciption taskDetails={taskDetails} />
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <SessionsList
                  taskId={taskDetails._id}
                  quanta={quanta}
                  setQuanta={setQuanta}
                  questionTypeMapping={taskDetails.mapping}
                  sessionsProgress={taskDetails.session_progress}
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default Sessions;
